export default __webpack_public_path__ + "static/media/logo.4a0a4bd9.webp";